$(window).on('beforeprint', function (event) {
  $(".js-ac-box--open-item").show();
  $(".js-ac-box").addClass("active");

}).on('afterprint', function (event) {
});


$(".js-ac-box--open-item").hide();
//1個目は表示
$(".js-ac-box").eq(0).find('.js-ac-box--open-item').show();
$(".js-ac-box").eq(0).addClass("active");

$(".js-ac-box").on("click", function () {
  $(this).find(".js-ac-box--open-item").slideToggle();
  $(this).toggleClass("active");
});
